import { SelectDropdown } from './default';

export class SelectDropdownObserver extends SelectDropdown {
  constructor(container, onChange) {
    super(container, onChange);

    this.onChange = onChange;
  }

  handleSelectOption(option) {
    const currentValue = option.getAttribute('data-value');

    this.onChange(currentValue);
    super.handleCloseOptions();
  }
}
